import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';
import { configuration } from 'src/environments/environment';

@Component({
  selector: 'app-patientboard-report',
  templateUrl: './patientboard-report.component.html',
  styleUrls: ['./patientboard-report.component.css']
})
export class PatientboardReportComponent {

  reportServer: string = 'http://192.168.2.20/ReportServer/Pages/ReportViewer.aspx';
  reportUrl: string = 'NEMR/PatientBoardAppointments';
  showParameters: string = ""; 
  //toolbar: string = "";
  parameters: any = {
   // "userList": "", //+RD9cxRgiqmrOXvp7OdfOA==
    "appDate" : "",
    "Permissionflag" : "True",
    "time" :"-360",
    "FacilityId": sessionStorage.getItem("FacilityId").toString()
   };
   language: string = "en-us";

   public ifrmaesrc: any;
   constructor(private route: ActivatedRoute,private router:Router,protected sanitizer: DomSanitizer) {
   
    this.route.queryParams.subscribe(params => {    
      this.parameters ={
        "userList":  '', //+RD9cxRgiqmrOXvp7OdfOA==
        "appDate" :  params['appDate'],
        "Permissionflag" : "True",
        "time" :"-360",
        "FacilityId": sessionStorage.getItem("FacilityId").toString()   
      };
  });
  var iframesrcParams = '';
  var o = this.parameters;
  var x = Object.keys(o);
  var rptquerystr = '';
  Object.getOwnPropertyNames(o).forEach(function(val, id, array){
   
    for(var i = 0; i < x.length; i++){
      if(x.length!=(id+1))
      rptquerystr += val + '=' + encodeURIComponent(o[x[id]]) + '&';
        else
        rptquerystr += val + '=' + encodeURIComponent(o[x[id]]) ;
        break;
    }
  });
  this.ifrmaesrc=  this.sanitizer.bypassSecurityTrustResourceUrl(configuration.reportsUrl + '?rname=' + this.reportUrl.split('/')[1] + '&' + rptquerystr);
    // this.reportServer = 'http://192.168.2.20/ReportServer/Pages/ReportViewer.aspx';
    // this. reportUrl= encodeURIComponent( this. reportUrl)
    this.showParameters="false";
  //  this.toolbar="true";
  this.sanitizer.bypassSecurityTrustResourceUrl( this.ifrmaesrc.src );
   }

}
